<template>
  <div class="p-2">
    <vs-row style="align-items: center">
      <h4 class="text-w text-gray">{{ header }}</h4> </vs-row
    ><br />

    <!-- <pre>{{data}}</pre> -->
    <vs-table max-items="10" pagination :data="data">
      <template slot="thead">
        <vs-th align="center" v-for="i in tableheader" :key="i">
          {{ i }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td> {{ tr.id }} </vs-td>

          <vs-td> A20000640930BB5B </vs-td>

          <vs-td> E8 </vs-td>

          <vs-td> true </vs-td>

          <vs-td> Storage </vs-td>
          <vs-td>
            <vs-icon icon="rss_feed" color="success"></vs-icon>
          </vs-td>
          <vs-td>
            <vs-icon icon="battery_full" color="success"></vs-icon>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: ["header"],
  data() {
    return {
      maxheight: "700px",
      tableheader: [
        "Name",
        "Mac Address",
        "Type",
        "Active Status",
        "Location",
        "Signal",
        "Battery",
      ],
      data: [
        {
          id: "LNG Storage Tank No.02",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "Vaporizer No.1",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "LNG Storage Tank No.01",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "Vaporizer No.2",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "Pressure Regulating unit",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
      ],
    };
  },
};
</script>

<style scoped>
.text-gray {
  /* color: #707070; */
  font-weight: 500;
}
</style>